export default __webpack_public_path__ + "static/media/espaco-laser.8d328ef5.png";